import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 9 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M5.843 3.194H9V.025H6.41a4.3 4.3 0 0 0-3.058 1.283A4.4 4.4 0 0 0 2.082 4.4v1.962H0V9.53h2.09v10.495h3.135V9.53H8.38L9 6.362H5.225V3.818a.64.64 0 0 1 .184-.44.62.62 0 0 1 .434-.184",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }